<template>
  <div class="w-full md:w-full h-full">
    <!-- <vs-input-number v-model="number"/> -->
    <div class="h-full flex-slider justify-between rounded-lg relative">
      <div class="w-1/6 flex items-center justify-center text-primary">
        <feather-icon icon="StarIcon" svgClasses="w-6 h-6" />
      </div>
      <div
        class="border border-r-0 w-1/6  hidden md:flex justify-center items-center rounded-l-lg cursor-pointer select-none"
        @mousedown="myTimeoutDecrementar"
        @mouseup="clearTimout"
        @mouseout="clearTimout"
      >
        <i class="material-icons select-none"> remove </i>
      </div>

      <div
        class="
          border border-l-0
          w-1/6
          flex
          md:hidden
         justify-center items-center rounded-l-lg cursor-pointer select-none
        "
        @click="disminuir()"
      >
        <i class="material-icons select-none"> remove </i>
      </div>

      <div class="border w-full h-auto md:h-full bg-whites relative">
        <div class="bg-success h-full md:h-full" :style="style"></div>
        <div class="w-full h-auto md:h-full flex justify-center items-center absolute top-0" :class="fontCounter">
          {{ counter }}
        </div>
      </div>
      <div
        class="
          border border-l-0
          w-1/6
          flex
          md:hidden
          justify-center
          items-center
          rounded-r-lg
          cursor-pointer
          select-none
        "
        @click="aumentar()"
      >
        <i class="material-icons select-none"> add </i>
      </div>
      <div
        class="
          border border-l-0
          w-1/6
          hidden
          md:flex
          justify-center
          items-center
          rounded-r-lg
          cursor-pointer
          select-none
        "
        @mousedown="myTimeoutAunmetar()"
        @mouseup="clearTimout"
        @mouseout="clearTimout"
      >
        <i class="material-icons select-none"> add </i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    question: {
      type: Object,
      required: true
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  mounted() {
    this.step = 100 / this.slider;

    if (this.counter > this.slider) {
      this.counter = this.slider;
      this.change({ ...this.Item, answer: String(this.counter) });
      this.$emit("input", String(this.counter));
    }
  },
  data() {
    return {
      number: 1,
      // counter: parseInt(this.Item.answer) || 0,
      slider: this.question.properties.size,
      minSlider: 0,
      step: 0,
      polling: null
    };
  },
  methods: {
    myTimeoutAunmetar() {
      this.polling = setInterval(this.aumentar, 90);
    },
    myTimeoutDecrementar() {
      this.polling = setInterval(this.disminuir, 90);
    },
    clearTimout() {
      clearTimeout(this.polling);

    },
    aumentar() {
      if (this.counter < this.slider) return this.counter++;
    },
    disminuir() {
      if (this.counter > this.minSlider) return this.counter--;
    }
  },
  computed: {
    counter: {
      get() {
        return parseInt(this.value) || 0;
      },
      set(value) {
        this.change(String(value), { ...this.Item, answer: String(value) });
        this.$emit("input", String(value));
      }
    },
    style() {
      return {
        width: `${this.step * this.counter}%`
      };
    },
    half() {
      return this.slider / 2;
    },
    fontCounter() {
      if (this.counter >= Math.trunc(this.half) + 1) return "text-white font-bold";
      return "font-bold";
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-slider {
  display: flex !important;
}
</style>
